import api from "../../Api/feathers-client";
import axios from "axios";

export const getWordsByPagination = async (searchString, language, page) => {
  return new Promise(async (resolve, reject) => {
    try {
      console.log("API getAssignmentData",{
          word_phrase: searchString,
          language: language,
          page: page,
        },);
      // return false;

      let response = await api.service("words-phrase").find({
        query: {
          word_phrase: searchString,
          language: language,
          page: page,
        },
      });

      resolve({
        status: 200,
        message: "All Words",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

export const getWordsLanguages = async (query) => {
  return new Promise(async (resolve, reject) => {
    try {
      // console.log("API getAssignmentData",params);
      // return false;

      let response = await api.service("words-phrase").find({
        query: query,
      });

      resolve({
        status: 200,
        message: "All Words",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};
